import { useState } from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import { Menu } from 'antd';
import { useSelector } from 'react-redux';

import Logo from '../Logo';
import { UserPanel } from './Components/UserPanel';
import { getSidebarNavItems } from './constants';

import './index.scss';

const SidenavLayout = () => {
  const location = useLocation();
  const { userDetails, marketplacePartnerData } = useSelector(
    ({ AuthReducer }) => AuthReducer,
  );
  const isCustomMarketplace = Boolean(
    userDetails?.defaultOrganization?.marketplacePartner,
  );
  const managedMarketplace =
    userDetails.defaultOrganization?.managedMarketplace;

  const isPreDealsTrainingWatched = userDetails?.watchedPreDealsTrainingAt;
  const isMissedOpportunitiesReportActive =
    userDetails?.defaultOrganization?.buyersAppFeatureFlags?.missedOpportunities
      ?.isActive;

  const isAllWaysCapital = Boolean(
    userDetails?.defaultOrganization?.marketplacePartner === 'all-ways-capital',
  );

  const [nav] = useState(
    getSidebarNavItems(
      userDetails?.defaultOrganization?._id,
      isPreDealsTrainingWatched,
      managedMarketplace,
      isMissedOpportunitiesReportActive,
      isAllWaysCapital,
    ),
  );
  const activeKey = nav.find(
    (item) =>
      matchPath(location.pathname, {
        path: item.label?.props?.to,
        exact: false,
        strict: false,
      })?.isExact,
  )?.key;

  const logoUrl = userDetails.defaultOrganization?.logoUrl;

  return (
    <div className="sidebar">
      <div>
        <Logo
          title="Buyer"
          userDetails={userDetails}
          marketplacePartnerData={marketplacePartnerData}
        />
        {logoUrl && !isCustomMarketplace && (
          <div className="account-logo">
            <img src={logoUrl} />
          </div>
        )}
        <Menu
          className="sidebar-menu"
          theme="light"
          mode="inline"
          selectedKeys={activeKey}
          items={userDetails.isCompletedOnboarding ? nav : []}
        />
      </div>
      <UserPanel />
    </div>
  );
};

export default SidenavLayout;
